<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="供应链中台配置" name="1">
                    <el-form ref="lihanztForm" :model="lihanztForm" :rules="rules" label-width="100px" class="form-box">
                        <el-form-item label="域名" prop="base_url">
                            <el-input v-model="lihanztForm.base_url" placeholder="请输入域名"  @blur="handleBaseUrlBlur"></el-input>
                        </el-form-item>

                        <el-form-item label="appid" prop="app_id">
                            <el-input v-model="lihanztForm.app_id" placeholder="请输入appid"></el-input>
                        </el-form-item>

                        <el-form-item label="appsecret" prop="app_secret">
                            <el-input v-model="lihanztForm.app_secret" placeholder="请输入appsecret"></el-input>
                        </el-form-item>

                        <el-form-item label="是否开启同步" prop="sync_open">
                            <el-switch v-model="lihanztForm.sync_open"></el-switch>
                        </el-form-item>

                        <el-form-item label="渠道名称" prop="channel_name">
                            <el-input v-model="lihanztForm.channel_name" placeholder="请输入渠道名称"></el-input>
                        </el-form-item>

                        <el-form-item label="渠道ID" prop="channel_id">
                            <el-input v-model="lihanztForm.channel_id" placeholder="请输入渠道ID"></el-input>
                        </el-form-item>

                        <el-form-item label="分销商ID" prop="distributor_id">
                            <el-input v-model="lihanztForm.distributor_id" placeholder="请输入分销商ID"></el-input>
                        </el-form-item>

                        <el-form-item label="分销商名称" prop="distributor_name">
                            <el-input v-model="lihanztForm.distributor_name" placeholder="请输入分销商名称"></el-input>
                        </el-form-item>

                        <el-form-item label="是否开启百联钱包" prop="sync_open">
                            <el-switch v-model="lihanztForm.okbaifu_open"></el-switch>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="savelihanztForm">提 交</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import {request} from '@/common/request';
import {deal} from '@/common/main';
import loadEvents from '@/utils/loading'

let loads = new loadEvents();
export default {
    name: '',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            activeName: '1',
            menuList: ['设置', '系统配置'],
            lihanztForm: {
                base_url: '',
                app_id: '',
                app_secret: '',
                sync_open: 0,
                channel_name: '',
                channel_id: '',
                distributor_id: '',
                distributor_name: '',
                okbaifu_open: 0
            },
            header: {},
            rules: {
                base_url: [
                    { required: true, message: '域名不能为空', trigger: 'blur' }
                ],
                app_id: [
                    { required: true, message: 'appid不能为空', trigger: 'blur' }
                ],
                app_secret: [
                    { required: true, message: 'appsecret不能为空', trigger: 'blur' }
                ],
       /*         channel_name: [
                    { required: true, message: '渠道名称不能为空', trigger: 'blur' }
                ],
                channel_id: [
                    { required: true, message: '渠道ID不能为空', trigger: 'blur' }
                ],
                distributor_id: [
                    { required: true, message: '分销商ID不能为空', trigger: 'blur' }
                ],
                distributor_name: [
                    { required: true, message: '分销商名称不能为空', trigger: 'blur' }
                ]*/
            }

        }
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadlihanztForm()
    },
    methods: {
        // tab切换
        handleClick(tab) {
            switch (tab.paneName) {
                case '1':
                    this.loadlihanztForm()
                    break
            }
        },
        // 供应链中台
        loadlihanztForm() {
            this.loading = true;
            request.get('/system/lihanzt/config').then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.lihanztForm = ret.data;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 供应链中台编辑
        savelihanztForm() {
            this.$refs.lihanztForm.validate((valid) => {
                if (valid) {
                    request.post('/system/lihanzt/config/edit', this.lihanztForm).then(ret => {
                        if (ret.code === 1) {
                            this.$message.success('编辑成功');
                            this.loadlihanztForm();
                            this.$refs.lihanztForm.resetFields();
                        } else {
                            this.$message.error(ret.msg);
                        }
                    });
                } else {
                    this.$message.error('请完善表单信息');
                    return false;
                }
            });
        },
        handleBaseUrlBlur() {
            if (this.lihanztForm.base_url && this.lihanztForm.base_url.endsWith('/')) {
                this.lihanztForm.base_url = this.lihanztForm.base_url.slice(0, -1);
            }
        },

    }
}
</script>
<style scoped>


.form-box {
    width: 100%;
}


.dialog_box .up {
    margin-top: 10px;
    margin-bottom: -10px;
}


</style>
